import { render, staticRenderFns } from "./side-smaller-ads.vue?vue&type=template&id=1a1b2466"
import script from "./side-smaller-ads.vue?vue&type=script&lang=js"
export * from "./side-smaller-ads.vue?vue&type=script&lang=js"
import style0 from "./side-smaller-ads.vue?vue&type=style&index=0&id=1a1b2466&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports